export const MainTheme = {
    bg: "#240115",
    emphasis: "#DE3C4B",
    secondary:"#CEC3C1",
    iconBg: "#DE3C4B"
}